import { apiPost } from "./api";

export default class ServicioPacientes {
	static crearPaciente(datosPaciente) {
		return apiPost("/pacientes/Nuevo", datosPaciente);
	}
	static editarPaciente(datosPaciente) {
		return apiPost("/pacientes/Editar", datosPaciente);
	}
	static getCURP(
		nombres,
		primerApellido,
		segundoApellido,
		fechaNacimiento,
		estadoCorto,
		generoCorto
	) {
		const data = {
			Nombres: nombres,
			PrimerApellido: primerApellido,
			SegundoApellido: segundoApellido,
			FechaNacimiento: fechaNacimiento,
			EstadoCorto: estadoCorto,
			GeneroCorto: generoCorto
		};
		return apiPost("/utilidades/CURP", data);
	}

	static get_pacientes(
		buscar_nombre,
		buscar_modulo,
		buscar_celular,
		buscar_email
	) {
		let data = {
			Nombre: buscar_nombre,
			Modulo: buscar_modulo,
			Celular: buscar_celular,
			Email: buscar_email
		};
		return apiPost("/pacientes/Listado/", data);
	}

	static getPerfilPaciente(pacienteId) {
		let data = {
			PacienteID: pacienteId
		};
		return apiPost("/pacientes/Perfil/", data);
	}

	static crearVisita(pacienteId) {
		let data = {
			PacienteID: pacienteId
		};
		return apiPost("/visita/Crear/", data);
	}

	static getDatosVisita(visitaId) {
		let data = {
			VisitaID: visitaId
		};
		return apiPost("/pacientes/Visita/", data);
	}

	static getInfo(pacienteId) {
		let data = {
			PacienteID: pacienteId
		};
		return apiPost("/pacientes/PacienteInfo/", data);
	}
}
